import { Alert } from "@mui/material";
import { useContext } from "react";
import { UserContext } from "../../contexts/UserContext";

export enum UserAccessTypes {
    ViewConstructor = "CTR",
    ManageSmsCampaigns = "SMS",
    ManageSales = "SAL",
    ManageCourses = "CRS",
    ManageUsers = "USR",
}

export default function PrivilegeAlert(props: { access: UserAccessTypes }) {
    const user = useContext(UserContext);

    return (
        <>
            {!user.hasAccessTo(props.access.valueOf()) && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    شما به این بخش دسترسی ندارید! برای دسترسی به این بخش با صاحب
                    حساب و یا شخص دارای درسترسی مدیریت کاربران ارتباط گرفته و
                    درخواست دسترسی به این بخش را اعلام نمایید.
                </Alert>
            )}
        </>
    );
}
